import React, { FC, useState, useEffect, useRef } from "react";
import { withRouter, generatePath } from "react-router-dom";
import { Button, Divider, Dropdown, Menu, Pagination, Select } from "antd";
import { Field, Form, Formik } from "formik";
import { deserialize } from "serializr";

import avatarPlaceholder from "../../assets/placeholder/avatar_placeholder.png";
import * as appRoutes from "../../routes/routeConstants/appRoutes";
import menuIcon from "../../assets/icons/menu-icon.svg";

//components
import TableComponent from "../../shared/components/TableComponent";
import AppHeader from "../../shared/components/AppHeader";
import DropdownField from "../../shared/components/DropdownField";
import DeleteAlert from "../../shared/components/DeleteAlert";
import Filters from "../../shared/components/Filters";
import EmptyState from "../../shared/components/EmptyState";
import PaginationComponent from "../../shared/components/PaginationComponent";

//models
import { Students } from "../../models/StudentsModel/students.model";
import { FilterStudent } from "../../models/StudentsModel/students.model";
import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
//service
import IStudentService from "../../services/InstituteService/student.service";
import CommonService from "../../services/CommonService/common.service";
import ClassroomService from "../../services/CourseServices/ClassroomService/classroom.service";
import Notification from '../../shared/components/Notification';
import { NotificationTypes } from '../../enums/notificationTypes';

//style
import "./students.scss";
import { BASE_URL, EXISITING_STUDENT_PRIVATE_DATA } from "../../routes/routeConstants/apiRoutes";
import { StudentPasswordForm } from "../Institute/InstituteDetails/InstituteStudents/InstituteStudentDetails/StudentPasswordForm";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import PrivateStudentForm from "./PrivateStudentForm/PrivateStudentForm";
import StudentService from "../../services/StudentService/student.service";
import { debug } from "console";


export const treeOptions = [
  {
    title: "CBSE",
    value: "0",
    children: [
      {
        title: "Class 5",
        value: "0-1",
        children: [
          {
            title: "Mathematics",
            value: "0-1-1",
          },
          {
            title: "Science",
            value: "0-1-2",
          },
          {
            title: "English",
            value: "0-1-3",
          },
        ],
      },
      {
        title: "Class 6",
        value: "0-2",
        children: [
          {
            title: "Mathematics",
            value: "0-2-1",
          },
          {
            title: "Science",
            value: "0-2-2",
          },
          {
            title: "English",
            value: "0-2-3",
          },
        ],
      },
    ],
  },
  {
    title: "ICSE",
    value: "1",
    children: [
      {
        title: "Class 5",
        value: "1-1",
        children: [
          {
            title: "Mathematics",
            value: "1-1-1",
          },
          {
            title: "Science",
            value: "1-1-2",
          },
          {
            title: "English",
            value: "1-1-3",
          },
        ],
      },
      {
        title: "Class 6",
        value: "1-2",
        children: [
          {
            title: "Mathematics",
            value: "1-2-1",
          },
          {
            title: "Science",
            value: "1-2-2",
          },
          {
            title: "English",
            value: "1-2-3",
          },
        ],
      },
    ],
  },
];
const Student: FC = (props: any) => {
  const [currentStudent, setCurrentStudent] = useState<any>();
  const [students, setStudents] = useState<Students[]>([]);

  const [loading, setLoading] = useState<boolean>(false);
  const [paginationMeta, setPaginationMeta] = useState<PaginationModel>({});

  const [showForm, setFormVisibility] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState<boolean>(false);
  const [showBlacklistAlert, setShowBlacklistAlert] = useState<boolean>(false);
  const [blacklistReason, setBlacklistReason] = useState<string>("");
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  const formRef = useRef<any>();
  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [showFilter, setFilterVisibility] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [filters, setFilters] = useState<FilterStudent>({
    CurrentPage: currentPage,
    Pagesize: pageSize,
  });

  const fetchStudents = (params: FilterStudent) => {
    setLoading(true);
    StudentService.fetchStudents(
      params,
      (students, meta: React.SetStateAction<PaginationModel>) => {
        setStudents(students);
        setPaginationMeta(meta);
      },
      () => { },
      () => { setLoading(false); }
    );
  };

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBoards(meta);
        // if (meta.length) {
        //   let value = Number(meta[0].value)
        //   setFilters((prevState) => { return { ...prevState, BoardId: value } })
        //   fetchGrades(value)
        // }
      },
      () => { },
      () => { }
    );
  };

  const fetchGrades = (boardId: number) => {
    let queryParams = `?page=${0}&board_id=${boardId}&search=${''}`
    ClassroomService.getClassroomsList(queryParams,
      (classrooms: any, pageMeta: any) => {
        const meta = deserialize(MetaModel, classrooms) as MetaModel[];
        setClassRooms(meta);
      },
      () => { },
      () => { },
    )
  };

  useEffect(() => {
    fetchStudents(filters);
    fetchBoards();
  }, []);

  const handlePageChange = (page: number) => {
    fetchStudents({ ...filters, CurrentPage: page, Pagesize: pageSize });
    setFilters({ ...filters, CurrentPage: page, Pagesize: pageSize });
  };


  useEffect(() => {
    handlePageChange(currentPage)
  }, [pageSize])

  // const handleSearch = (value: string) => {
  //   fetchStudents({ CurrentPage: currentPageNumber, Pagesize: 15, search: value });
  // };


  const menu = (
    <Menu className="courses__card__menu">
      <Menu.Item
        key="edit"
        onClick={() => {
          setShowBlacklistAlert(true);
        }}
      >
        {currentStudent?.isBlocked ? "Remove from " : "Add to" } blacklist
      </Menu.Item>
      <Menu.Divider/>
      <Menu.Item
        key="update"
        onClick={() => {
          setFormVisibility(true)
        }}
      >
        Edit Student
      </Menu.Item>
      <Menu.Divider/>
      <Menu.Item
        key="update"
        onClick={() => {
          setShowDrawer(true);
        }}
      >
        Update Password
      </Menu.Item>
      <Menu.Divider/>
      <Menu.Item
        key="delete"
        onClick={() => {
          setShowDeleteAlert(true);
        }}
      >
        Delete Student
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Student ID",
      dataIndex: "id",
      key: "id",
      sorter: (a: any, b: any) => (a.id > b.id ? 1 : -1),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string) => (
        <>
          <img src={avatarPlaceholder} alt="" className="table-image" /> {name}
        </>
      ),
      sorter: (a: any, b: any) => (a.name > b.name ? 1 : -1),
    },
    {
      title: "Student Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Student Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Class",
      dataIndex: "classRoom",
      key: "classRoom",
      render: (classRoom: any, record: any, index: number) => (
        <div>
          {classRoom?.name}
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "",
      key: "action",
      render: (text: string, record: any, index: number) => (
        <div
          onClick={(event) => {
            setCurrentStudent(record);
            event.stopPropagation();
          }}
        >
          <Dropdown
            overlay={menu}
            trigger={["click"]}
            placement={"bottomRight"}
            className="course__dropdown"
            onVisibleChange={(visible) => {
              console.log(visible);
            }}
          >
            <img src={menuIcon} alt="" />
          </Dropdown>
        </div>
      ),
    },
  ];

  const refreshHandler = () => {
    fetchStudents(filters);
  };

  const deleteStudent = () => {
    IStudentService.deletePrivateStudent(
      currentStudent?.id,
      () => {
        setShowDeleteAlert(false);
        fetchStudents(filters);

        Notification({ message: "Student", description: "Student deleted successfully", type: NotificationTypes.SUCCESS });
      },
      () => {},
      () => {}
    );
  }

  const handleUpdate = () => {
    IStudentService.updateStudent(
      currentStudent.id,
      {isBlocked: !currentStudent.isBlocked, blockedReason: blacklistReason},
      () => {
        refreshHandler();
        setBlacklistReason('')
        fetchStudents(filters);
        setShowBlacklistAlert(false);
        Notification({ message: "Blacklist", description: `Student ${currentStudent?.isBlocked ? 'restored' : 'blacklisted'} successfully`, type: NotificationTypes.SUCCESS });
      },
      () => { },
      () => { }
    );
  };

  const downloadStudentReport = () => {
    var element = document.createElement("a");
    const user = JSON.parse(localStorage.getItem("token") || "")
    
    element.href = `${BASE_URL}${EXISITING_STUDENT_PRIVATE_DATA}?access_token=${user.access_token}`;
    element.click();
  };

  return (
    <div className="page-view">
      {/* <EmptyState text={"Coming soon..."} /> */}

      <AppHeader
        headerText="Students"
        showSearch={false}
        // handleSearch={handleSearch}
        // handleHeaderAction={() => {
        //   props.history.push(appRoutes.STUDENTS_BLACKLIST);
        // }}
        // buttonContent="Blacklist"
        showButton={false}
        showBreadCrumb={false}
        showFilter={true}
        buttonIcon={null}
        handleFilter={() => setFilterVisibility(true)}
      />

      <div className="download-btn-box">
        <Button className="download-btn" onClick={() => downloadStudentReport()}>
          <p className="btn-text">Download Data</p>
        </Button>
        <Button className="download-btn" onClick={() => setFormVisibility(true)}>
          <p className="btn-text">Add Student</p>
        </Button>
      </div>

      <TableComponent
        pagination={{...paginationMeta, pageSize: pageSize}}
        setCurrentPage={setCurrentPage}
        setPageSize={setPageSize}
        fetchList={handlePageChange}
        loading={loading}
        dataSource={students}
        columns={columns}
        handleRowClick={(e: any, record: any) => {
          props.history.push(
            generatePath(appRoutes.STUDENT_DETAILS, { studentId: record.id }),
            record
          );
        }}
      />
       <DeleteAlert
        visible={showDeleteAlert}
        setVisible={setShowDeleteAlert}
        deleteContent={"Are you sure to delete this student?"}
        deleteWarning={
          "On deleting, student will be permanently deleted from the system. All associated data will be deleted as well."
        }
        logo={ avatarPlaceholder }
        contentTitle={currentStudent?.name}
        contentSubject={currentStudent?.studentPhone}
        blacklist={undefined}
        setBlacklistReason={undefined}
        handleDelete={deleteStudent}
      />
      <PrivateStudentForm
        visible={showForm}
        closeHandler={() => {
          setFormVisibility(false);
          setCurrentStudent(undefined);
        }}
        data={currentStudent}
        refreshList={refreshHandler}
        apiMethod={() => fetchStudents(filters)}
      />
      <StudentPasswordForm
        isPrivate={true}
        open={showDrawer}
        setOpen={setShowDrawer}
        onClose={() => setShowDrawer(false)}
        studentData={currentStudent}
      />
      <DeleteAlert
        visible={showBlacklistAlert}
        setVisible={setShowBlacklistAlert}
        deleteContent={"Are you sure to add the student to blacklist?"}
        deleteWarning={
          "On blacklisting, Student loses access to the application"
        }
        logo={avatarPlaceholder}
        contentTitle={currentStudent?.fullName}
        contentSubject={currentStudent?.studentPhone}
        blacklist={currentStudent?.isBlocked ? "remove" : 'add'}       
        setBlacklistReason={setBlacklistReason}
        handleDelete={handleUpdate}
      />
      <Formik
        initialValues={filters}
        onSubmit={() => { }}
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue, resetForm }) => (
          <Filters
            expand={showFilter}
            handleApply={() => {
              fetchStudents(values)
              setFilterVisibility(false)
            }}
            handleReset={() => {
              resetForm({});
              setFilterVisibility(false);
              setFilters(filters)
              fetchStudents(filters);
            }}
            closeHandler={() => setFilterVisibility(false)}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="filter-form__input">
                <div className="filter-form__label">Branch</div>
                <DropdownField
                  name="BoardId"
                  placeholder="Select branch"
                  options={boards}
                  value={values?.BoardId}
                  onChange={(value) => {
                    setFieldValue("BoardId", value);
                    fetchGrades(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Class</div>
                <DropdownField
                  name="GradeId"
                  placeholder="Select class"
                  options={classRooms}
                  value={values?.GradeId}
                  onChange={(value) => {
                    setFieldValue("GradeId", value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
            </Form>
          </Filters>
        )}
      </Formik>
    </div>
  );
};

export default withRouter(Student);
